export const EXPENSES_STORE = 'expenses/store';
export const EXPENSES_DESTROY = 'expenses/destroy';

export default {
  EXPENSES_STORE,
  EXPENSES_DESTROY,
};
